<template>
	<div>
		<h1 class="page-header"><i class="fab fa-delicious"></i> Összesítőpult <small></small></h1>
		<h2>üdv</h2>
	</div>
</template>

<script>	
	export default {
		data() {
			return {
			}
		},
		computed:{
			user(){
				return this.$store.state.user;
			},
		},
		created() {
			
		},
		methods: {
		}
	};
</script>